import {
    getActivationTokenHeader,
    getStoredPartnerActivation,
    isActivationTokenExpired,
} from '@rhg/utils/partner-activation';

/**
 * The stored partner activation, treating an expired token as absent without
 * removing it from storage.
 */
export function usePartnerActivation() {
    const storedActivation = getStoredPartnerActivation();
    const header = storedActivation
        ? getActivationTokenHeader(storedActivation.token)
        : undefined;
    const stored =
        header && isActivationTokenExpired(header.expiresAt)
            ? undefined
            : storedActivation;

    return {
        activationToken: stored?.token,
        partnerId: stored?.partnerId,
        hasActivationToken: !!stored,
        isActivationForPartner: (partnerId?: string | null): boolean =>
            !!stored && stored.partnerId === partnerId,
    };
}

/**
 * The stored activation token, only when it was issued for `partnerId`.
 * Returns `undefined` for a token stored for a different partner and leaves
 * the stored value untouched.
 */
export function useActivationTokenForPartner(partnerId?: string | null) {
    const { activationToken, partnerId: storedPartnerId } =
        usePartnerActivation();
    const isForPartner =
        !!activationToken && !!partnerId && storedPartnerId === partnerId;

    return {
        activationToken: isForPartner ? activationToken : undefined,
        hasActivationToken: isForPartner,
    };
}
